import React from "react";
import { CheckCircle2, XCircle } from "lucide-react";

interface TicketActionSectionProps {
  /** Indica si actualmente se está imprimiendo */
  isPrinting: boolean;
  /** Acción al confirmar impresión */
  onConfirm: () => void;
  /** Acción al cancelar impresión */
  onCancel: () => void;
}

/**
 * 🎛️ TicketActionSection
 *
 * Sección elegante de confirmación de impresión.
 * Muestra mensaje principal y botones con mejor jerarquía visual.
 */
const TicketActionSection: React.FC<TicketActionSectionProps> = ({
  isPrinting,
  onConfirm,
  onCancel,
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-4 text-center">
      {/* 🧾 Mensaje dinámico */}
      {!isPrinting ? (
        <>
          <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-100">
            Confirmar impresión
          </h3>
          <p className="text-sm text-gray-600 dark:text-gray-400 max-w-xs">
            ¿Desea imprimir el ticket de esta transacción?
          </p>
        </>
      ) : (
        <>
          <h3 className="text-lg font-semibold text-primary">
            Imprimiendo ticket...
          </h3>
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Espere mientras se envía la orden a la impresora
          </p>
        </>
      )}

      {/* ⚙️ Botones */}
      {!isPrinting && (
        <div className="mt-2 flex items-center justify-center gap-4">
          <button
            onClick={onCancel}
            className="flex items-center gap-2 rounded-md bg-[#DC3545] px-6 py-2 text-sm font-medium text-white shadow-md transition hover:bg-[#b42a37] focus:ring-2 focus:ring-red-400 focus:outline-none"
          >
            <XCircle size={18} /> No
          </button>

          <button
            onClick={onConfirm}
            className="flex items-center gap-2 rounded-md bg-primary px-6 py-2 text-sm font-medium text-white shadow-md transition hover:bg-primary/90 focus:ring-2 focus:ring-primary focus:outline-none"
          >
            <CheckCircle2 size={18} /> Sí
          </button>
        </div>
      )}
    </div>
  );
};

export default TicketActionSection;
